import './lists.css';

/**
 * "Show N more" load-more for work queues and list-detail left columns
 * (00-ds-09 §2 / §4, D148): no numbered pages in a queue. UI-only — the next
 * page is fetched cursor-based on the server (§8).
 */
export function LoadMore({
  loaded,
  total,
  step = 50,
  loading = false,
  onMore,
  label,
}: {
  loaded: number;
  total: number;
  /** How many more to request (shown in the button: "Show 50 more"). */
  step?: number;
  loading?: boolean;
  onMore: () => void;
  /** Override the button text; defaults to "Show {remaining, capped at step} more". */
  label?: string;
}) {
  if (loaded >= total) return null;
  const remaining = total - loaded;
  const next = Math.min(step, remaining);
  return (
    <div className="lx-loadmore">
      <button type="button" className="lx-loadmore-btn" disabled={loading} onClick={onMore}>
        {loading ? 'Loading…' : (label ?? `Show ${String(next)} more`)}
      </button>
      <div className="lx-loadmore-count">
        Showing {loaded.toLocaleString()} of {total.toLocaleString()}
      </div>
    </div>
  );
}
